<!-- CheckboxCell.vue -->
<template>
  <div class="d-flex align-items-center">
    <span>
      <b-form-checkbox
        size="lg"
        variant="danger"
        v-model="row.rowSelected"
        @change="onPrompt"
        class="mr-1 _red-checkbox"
      >
      </b-form-checkbox>
    </span>

    <span v-if="listingType === 'rental'" class="ml-2" @click="onDelete">
      <font-awesome-icon
        :icon="['fas', 'trash-alt']"
        class="_cursor-pointer text-vb-red"
      />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    // Tabulator provides the row data
    row: { type: Object, required: true },
    listingType: { type: String, default: "" },
    // Callbacks to trigger parent methods
    onPromptRow: { type: Function, required: true },
    onDeleteRow: { type: Function, required: true }
  },
  methods: {
    onPrompt() {
      this.onPromptRow(this.row);
    },
    onDelete() {
      this.onDeleteRow({
        rid: this.row.rid,
        rowData: this.row
      });
    }
  }
};
</script>
